// @ts-nocheck
/*
  <pb-eoy-giftbags> — EOY 2026 giftbags section (sections/pb-eoy-giftbags.liquid)
  - Tiles are toggle buttons (aria-pressed). Click / tap / Enter / Space opens
    a tile (its large photo); one open at a time; the open one closes it again.
    Click / tap only — no hover effect (ticket).
  - Open animation: the photo grows out of the thumbnail (CSS transition on
    .pb-eoy-gb__photo, assets/pb-eoy-giftbags.css). On mobile the card itself
    also changes height (156 → 4:5 of its width); that height change is animated
    here, since CSS can't transition to/from the closed card's auto height: an inline
    px height (with !important — the stylesheet sets height: auto !important,
    which would beat a WAAPI animation) goes from the old to the new height
    through the CSS height transition, then is removed.
  - "Shop nu de giftbox" is a plain anchor link: no JS.
  - Theme editor: selecting a giftbag block opens its tile.
*/
(() => {
  if (customElements.get('pb-eoy-giftbags')) return;

  const DURATION = 450; // keep in sync with --pb-eoy-gb-open-ms in the CSS

  class PbEoyGiftbags extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('[data-gb-tile]'));
      this.open = null;

      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      const tile = event.target.closest('[data-gb-tile]');
      if (!tile || !this.contains(tile) || tile.disabled) return;
      this.setOpen(this.open === tile ? null : tile);
    }

    onBlockSelect(event) {
      const tile = this.tiles.find((t) => t.dataset.blockId === event.detail?.blockId);
      if (tile && !tile.disabled && tile !== this.open) this.setOpen(tile);
    }

    setOpen(next) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Tiles whose open state changes: current height (mid-animation too), then the new one.
      const changing = this.tiles.filter((t) => t === this.open || t === next);
      const before = changing.map((t) => t.getBoundingClientRect().height);
      changing.forEach((t) => this.clearHeight(t));

      this.open = next;
      this.tiles.forEach((t) => {
        t.setAttribute('aria-pressed', String(t === next));
        t.toggleAttribute('data-open', t === next);
      });

      if (reduced) return;
      const after = changing.map((t) => t.getBoundingClientRect().height);
      changing.forEach((tile, i) => {
        if (Math.abs(after[i] - before[i]) < 1) return; // desktop: same size, nothing to do
        tile.style.setProperty('height', `${before[i]}px`, 'important');
        tile.getBoundingClientRect(); // commit the start height before the transition
        tile.setAttribute('data-resizing', '');
        tile.style.setProperty('height', `${after[i]}px`, 'important');
        tile.pbHeightTimer = setTimeout(() => this.clearHeight(tile), DURATION + 50);
      });
    }

    clearHeight(tile) {
      clearTimeout(tile.pbHeightTimer);
      tile.removeAttribute('data-resizing');
      tile.style.removeProperty('height');
    }
  }

  customElements.define('pb-eoy-giftbags', PbEoyGiftbags);
})();
